// src/shared/rota-country.js - the weekend and the busy days, per country (v133.94). Pure, no globals.
//
// Matt, 9 Oct 2026: "when i was in qatar, they told me they dont use the AI rota as it doesnt understand the
// friday Saturday weekend." They were right. Qatar's weekend is Friday and Saturday, but the AI rota's default
// (in the admin generator, the staff app's generator and its rules panel, and the rules screen's own defaults)
// was Thursday and Friday, so it protected Thursday and Friday and could give staff Saturday off; only one
// minor screen said Friday and Saturday. And the busy days defaulted to Thursday to Sunday everywhere, though
// Sunday is an ordinary working day in Qatar (the first day of its week). One answer now, used everywhere.

export const UAE_WEEKEND = ['Saturday', 'Sunday'];
export const QATAR_WEEKEND = ['Friday', 'Saturday'];
export const UAE_PEAK = ['Thursday', 'Friday', 'Saturday', 'Sunday'];
export const QATAR_PEAK = ['Thursday', 'Friday', 'Saturday'];
// The rules screen pre-filled these and saved them with everything else, so a saved copy of either is the old
// default rather than a choice: it is read as the right answer for the country.
const OLD_QATAR_WEEKEND = ['Thursday', 'Friday'];

const sameDays = (a, b) => Array.isArray(a) && a.length === b.length && b.every((d) => a.indexOf(d) !== -1);
const given = (a) => Array.isArray(a) && a.length > 0;

// tp: the store's trading pattern (rules), may be empty -> the days nobody may have off
export function weekendFor(isQatar, tp) {
  const t = tp || {};
  if (!isQatar) return given(t.uaeWeekend) ? t.uaeWeekend : UAE_WEEKEND;
  return given(t.qatarWeekend) && !sameDays(t.qatarWeekend, OLD_QATAR_WEEKEND) ? t.qatarWeekend : QATAR_WEEKEND;
}

// -> the busiest days (most cover, late shifts). One saved list serves both countries on the rules screen, so a
// Qatar store reads the UAE default as Qatar's own; any other list someone chose is used as it is.
export function peakDaysFor(isQatar, tp) {
  const saved = (tp || {}).peakDays;
  if (!isQatar) return given(saved) ? saved : UAE_PEAK;
  return given(saved) && !sameDays(saved, UAE_PEAK) ? saved : QATAR_PEAK;
}
